export default {
  'processGroup.title': 'Gestionar Grupos de Procesos',
  'processGroup.parentProcessGroup': 'Grupo de Procesos Padre',
};
